import React from "react";
import {
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from "@mui/material";

const FeedBackConfirmationModal = ({
  open = false,
  handleClose = () => {},
}) => {
  return (
    <Dialog open={open}>
      <DialogContent>
        <Typography variant="h5">
          Thank you for being the architects of our future. Your feedback isn't
          just heard; it's cherished, analyzed, and woven into the fabric of our
          growth. Together, let's turn feedback into the wind beneath our wings!
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={() => handleClose()}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FeedBackConfirmationModal;
